import { QuotaInfo } from "@models/services/booking";

export const BOOKING_CONSTANTS = {
  INTERVAL_15_MINUTES: 15,
  INTERVAL_30_MINUTES: 30,
  MINS_IN_HOUR: 60,
  ODD_MINUTE_MARKS: [15, 45],
  ROUNDED_0_MINUTE_MARK: 0,
  ROUNDED_30_MINUTE_MARK: 30,
  TEXT: "Text",
  WIDTH_PER_SLOT: 15,
};

export const GUEST_COUNT_INVALID_CHARACTERS = ["-", ".", "+", "e", "E"];

export const PAYMENT_OPTIONS = {
  CARD: "card",
  CASH: "cash",
  INSTANT_PAYMENT: "instant-payment",
  INVOICE: "invoice",
  NONE: "none",
  TWINT: "twint",
};

export const PAYMENT_STATUS = {
  BILLED: "BILLED",
  CANCELLED: "CANCELLED",
  CREDITNOTE: "CREDITNOTE",
  DECLINED: "DECLINED",
  DRAFT: "DRAFT",
  FAILED: "FAILED",
  INITIATED: "INITIATED",
  OPEN: "OPEN",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
  PARTPAYMENT: "PARTPAYMENT",
  PAYMENT_SCHEDULED: "PAYMENT_SCHEDULED",
  SCHEDULED: "SCHEDULED",
  SUCCESS: "SUCCESS",
  UNTRACKED: "UNTRACKED",
};

export const SCHEDULED_FROM = {
  BEFORE_END_OF_BOOKING: "BEFORE_END_OF_BOOKING",
  BEFORE_START_OF_BOOKING: "BEFORE_START_OF_BOOKING",
  ON_BOOKING: "ON_BOOKING",
} as const;

export const SCHEDULED_STATUS = {
  INACTIVE: "INACTIVE",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
} as const;

export const ALLOWED_SCHEDULED_STATUSES: string[] = [
  SCHEDULED_STATUS.PAYMENT_SUCCESS,
  SCHEDULED_STATUS.PAYMENT_FAILED,
  SCHEDULED_STATUS.INACTIVE,
];

export const REFUND_STATUS = {
  FAIL: "fail",
  INITIATED: "initiated",
  SUCCESS: "success",
} as const;

export const SOURCE = {
  PWA: "pwa",
  WEB: "web",
};

export const USER_TYPE = {
  allMembers: "allMembers",
  EXTERNALUSER: "external-users",
  GUEST: "guests",
  MEMBER: "members",
  otherContacts: "otherContacts",
};

export const USER_ROLE = {
  GUEST_ROLE: "ROLE_GUEST",
  ORGANIZER_ROLE: "ROLE_ORGANIZER",
};

export const HOLIDAY_TREAT_AS_TYPE = {
  CLOSED: "CLOSED",
  PARTIALLY_CLOSED: "PARTIALLY-CLOSED",
};

export const TIME_CONSTANTS = {
  END_OF_DAY: "23:59",
  INVALID_END: "24:00",
  START_OF_DAY: "00:00",
  START_OF_DAY_15_MINUTE_MARK: "00:15:00",
};

export const BOOKING_ADVANCE_DURATION = {
  DAYS: "DAYS",
  HOURS: "HOURS",
  MINUTES: "MINUTES",
};

export const QUOTA_INFO_ARRAY: (keyof QuotaInfo)[] = [
  "MAX_ACTIVE_BOOKING",
  "MAX_BOOKING",
];

export const KIOSK_SETUP_CONSTANTS = {
  HOUSEHOLD: "household",
  PIN_INDIVIDUAL: "pin-individual",
  PIN_SHARE_ALL: "pin-share-all",
  SELF: "self",
} as const;

export const KIOSK_HEIGHT = {
  CALENDAR_HEADER_HEIGHT: 120,
  CONTAINER_MARGINS: 28,
  FOOTER_HEIGHT: 148,
  NAVBAR_HEIGHT: 80,
  NON_KIOSK_MAX_HEIGHT: 500,
};

export const SHOW_BOOKING_TYPES = ["training", "camp_tournament"];

export const SHOW_HIDDEN_BOOKING_TYPES = [
  "training",
  "camp_tournament",
  "maintenance",
  "blocking",
];
export const BLOCKING = "blocking";

export const SAVED_CARD_MODAL_TIMINGS = {
  COUNTDOWN_DECLINED_SECONDS: 7,
  COUNTDOWN_SUCCESS_SECONDS: 10,
  POLL_INTERVAL_MS: 5000,
  POLL_TIMEOUT_MS: 60000,
  SAFETY_NET_TIMEOUT_SECONDS: 65,
  TAKING_LONGER_THRESHOLD_SECONDS: 40,
  TICK_INTERVAL_MS: 1000,
} as const;
